<template>
  <div ref="floor3D" class="floor3D" :style="floorData.length <= 4 ? 'align-items: center;' : ''">
    <div class="floor-content">
      <template v-for="(item, index) in floorData">
        <div
          :key="item.GpNo"
          class="floor"
          :style="{
            top: 50 + index * -1 + 'px',
          }"
          @mouseover="hoverIndex = index"
          @mouseleave="hoverIndex = -1"
          @click="handleClick(item)"
        >
          <div
            :class="[hoverIndex === index ? 'floor-name active' : 'floor-name']"
            :style="{
              top: 50 + index * -1 + 'px',
              zIndex: 10 - index,
            }"
          >
            <div class="floor-txt">
              <span>
                {{ item.GpName }}
              </span>

              <span>
                {{ item.Txt }} {{ item.Percentage }}
              </span>
            </div>
          </div>
          <div :class="{ 'shift-right': hoverIndex === index }" style="transition: transform 0.3s ease">
            <!-- 基础楼层 -->
            <div class="floor-bg" />
            <div class="floor-color head-light" />
            <div class="floor-color glow">
              <canvas
                :id="'canvasBg_'+ index"
                width="500"
                height="150"
                style="opacity: 0.7"
              />
            </div>

            <!-- 楼层着色 -->
            <!-- <div class="floor-color " :style="{ backgroundColor: item.BgColor }"></div> -->
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {  GetSchemeDetailByGpNo} from '@/axios/IDesign'
import OppleAreaMap from '@/components/OppleAreaMap/index.js';
import eventBus from '@utils/eventBus'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
    },

    floorColor: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      hoverIndex: -1, // 当前鼠标悬停的索引
      floorData: [], // 楼层数据
      SchemeDetailPromiseAll: [],//全部房间信息
      areaMaps: [], // 全部实例
      allResults: [], //全部房间信息
    }
  },
  watch: {
    data: {
      handler(val) {
        const newVal = JSON.parse(JSON.stringify(val))
        this.floorData = this.flattenLevel3Nodes(newVal)

        this.floorData.forEach((item, index) => {
          this.SchemeDetailPromiseAll.push(
            GetSchemeDetailByGpNo({
              projectCode: this.$store.state.projectcode,
              gpNo: item.GpNo
            })
          )
      })
      this.getGetSchemeDetailByGpNo()
      eventBus.$emit('hidenVisualTree');

      },
      deep: true,
      immediate: true,
    },
    floorColor: {
      handler(val) {
        this.getFloorStyle()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      const container = this.$refs.floor3D
      if (container) {
        container.scrollTop = container.scrollHeight // 滚动到底部
      }

      

      // this.getGetSchemeDetailByGpNo()
    })    
  },
  methods: {
    handlerData(list) {
      return list.map(item => {
        const color =  this.floorColor.find(floor => +floor.Gpno === +item.GpNo)?.Color || 'rgba(198, 198, 198, 0)'
        const data = Number((Math.random() * 60).toFixed(2))
        return  {
            name: item.RoomName,
            color,
            data,
            positions: (item.Lines || []).map(line => ({ x: line.Start.X , y: line.Start.Y  })).concat({ x: item.Lines[item.Lines.length - 1].End.X, y: item.Lines[item.Lines.length - 1].End.Y })
        }
      })
    },

    reStoreCanvas() {
      this.allResults.forEach((item, index) => {
          // if(item?.Result?.Rooms.length>0){
            this.areaMaps[index].reStore({
              dom: '#canvasBg_' + index,
              bg: item?.Result?.Images[0]?.Image || '',
              rooms: this.handlerData(item.Result.Rooms)
            })
          // }
      })
    },
    
    async getGetSchemeDetailByGpNo() {
      try {
        const results = await Promise.all(this.SchemeDetailPromiseAll);
        // 这里可以处理结果 result1, result2, result3
        if (results.length === 0) {
          return
        }

        this.allResults = results

        debugger
        results.forEach((item, index) => {
          // if(item?.Result?.Rooms.length > 0){
            const map = new OppleAreaMap({
              dom: '#canvasBg_' + index,
              bg: item?.Result?.Images[0]?.Image || '',
              rooms: this.handlerData(item.Result.Rooms)
            });

            this.areaMaps.push(map)
          // }
          
        })

      } catch (error) {
        // 处理错误
        console.error(error);
      }
    
    },
    // 获取楼层背景样式
    getFloorStyle() {
      this.floorData.forEach(floor => {
        const status = this.floorColor.find(item => {
          return +item.Gpno === +floor.GpNo
        })
        floor.BgColor = ''

        // 获取优先级样式
        if (status?.Color) {
          floor.BgColor = status.Color
          floor.Txt = status.Txt
          floor.Percentage = status.Percentage
        } else {
          floor.BgColor = 'rgba(198, 198, 198, 1)'
          floor.Txt = ''
          floor.Percentage = ''
        }
      })

      // this.$nextTick(() => {

     let timer = setTimeout(() => {
        this.reStoreCanvas()
      }, 2000)
      // })


      this.$forceUpdate()
    },
    getBgImages(path) {
      const img = JSON.parse(path)
      console.log("🚀 ~ getBgImages ~ img:", img)
      if (path) {
        return `url(${img[0].Image})`
      }
      return 'rgba(198, 198, 198, 1)'
    },
    handleClick(data) {
      eventBus.$emit('canvas-emit-tree-id', data.GpNo)
      this.$emit('goMap', data)
    },
    flattenLevel3Nodes(data, level = 3) {
      let result = []

      function recurse(node) {
        if (node.Level === level) {
          result.unshift({
            GpNo: node.GpNo,
            GpName: node.GpName,
            Level: node.Level,
            Path: node.Path,
            Childs: node.Childs,
            BgColor: 'rgba(198, 198, 198, 1)',
            Txt : '',
            Percentage: ''
          })
        }
        if (node.Childs && node.Childs.length > 0) {
          node.Childs.forEach(child => recurse(child))
        }
      }

      data.forEach(item => recurse(item))
      return result
    },
  },
}
</script>
<style lang="scss" scoped>
.floor3D {
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 1;
  background: url('@/assets/img/floor3d/bg.png') no-repeat center center;
  background-size: cover;
  background-color: #000;
  height: calc(100vh - 60px);
  overflow: scroll;


  .no-room{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #fff;
    z-index: 3;
  }

  .floor-name {
    position: absolute;
    left: -210px;
    width: 100px;

    .floor-txt{
      position: absolute;
      top: 0;
      left: -10px;
      display: flex;

      flex-direction: column;
      width: 110px;
      height: 50px;
      line-height: 24px;
      background: url('@/assets/img/floor3d/floor-name.png') no-repeat;
      background-size: 100%;
      z-index: 3;
    }

    span {
      padding: 0 5px;
      color: #fff;
      font-size: 14px;
      display: block;
      max-width: 120px;
      min-width: 50px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .floor-name::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 110%;
    width: 200px;
    height: 36px;
    background: url('@/assets/img/floor3d/default.svg') no-repeat;
  }

  .floor-name::after {
    content: '';
    position: absolute;
    top: 28px;
    left: 126px;
    height: 138px;
    border-left: 3px dashed rgba(255, 255, 255, 0.2);
  }

  .floor:last-child {
    .floor-name::after {
      display: none;
    }
  }

  .active {
    .floor-txt {
        background: url('@/assets/img/floor3d/floor-name-active.png') no-repeat;
        background-size: 100%;

    }
  }

  .active::before {
    background: url('@/assets/img/floor3d/active.svg') no-repeat;
  }

  .floor-name-act {
    background: #35bfff;
  }

  .floor-content {
    width: 600px;
    // margin-bottom: 50px;
  }
  .floor {
    position: relative;
    width: 100%;
    top: -10px;
    transition: transform 0.3s ease;
    cursor: pointer;
    .floor-bg {
      position: relative;
      width: 100%;
      height: 178px;
      background: url('@/assets/img/floor3d/floor.png') no-repeat;
      background-size: 100%;
      z-index: 2;
      opacity: 0.9;
    }
  }

  .floor:last-child {
    margin-bottom: 70px;
  }

  

  .floor-color {
    position: absolute;
    top: 10px;
    left: 48px;
    width: 500px;
    height: 150px;
    background-color: rgb(198, 198, 198);
    transform: perspective(200px) rotateX(21deg);
    z-index: 1;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 2px 10px 15px rgba(255,255,255,.65);

    // background: url('https://appresource.opple.com/media/business/5517/20241210163505_27.png') no-repeat;
    
    &.head-light {
      top: -23px;
      z-index: 3;
      width: 500px;
      height: 150px;
      left: 48px;
      transform: perspective(200px) rotateX(27deg);
      background-color: transparent;
      box-shadow: 0 6px 9px rgba(255, 255, 255, 0.6)
    }
  }

  // .floor {
  //   position: relative;
  //   transition: transform 0.3s ease;
  // }

  /* 默认位置 */
  .floor-bg,
  .floor-color {
    transition: background-color 1s ease-in-out; /* 背景色和透明度的过渡效果 */
    transition: transform 0.3s ease;
  }

  /* 点击时向右偏移 */
  .shift-right {
    transform: translateX(50px); /* 偏移 100px */
  }

  // .shift-right {
  //   transform: rotateX(0) scale(1.5); /* 偏移 100px */
  //   z-index: 3;
  //   border: 6px solid #555;
  // }

  /* 外发光效果 */
  .glow {
    // box-shadow: inset 0 0 30px 20px rgba(255, 255, 255, 1), inset 0 0 50px 20px rgba(255, 255, 255, 0.8);
  }


  /* 定义呼吸动画 */
  @keyframes glow-breath {
    0% {
      box-shadow: 0 0 10px 0px rgba(255, 255, 255, 0.3)
    }
    50% {
      box-shadow: 0 0 15px 0px rgba(255, 255, 255, 0.4), 
                  // 0 0 15px 20px rgba(255, 255, 255, 0.4); /* 呼吸增强 */
    }
    100% {
      box-shadow:  0 0 25px 0px rgba(255, 255, 255, 0.5), 
                  //  0 0 70px 20px rgba(255, 255, 255, 0.4), /* 呼吸增强 */
                  //  0 0 90px 25px rgba(255, 255, 255, 0.6); /* 回到初始状态 */
    }
  }

  @keyframes glow1 {
    0% {
      opacity: 0.5;
      // box-shadow: 0 0 20px 10px rgba(251, 247, 174, 0.8);
    }
    100% {
      opacity: 1;
      // box-shadow: 0 0 30px 15px rgba(251, 247, 174, 1);
    }
  }
}
</style>
